<template>
  <div class="md:mx-14 mx-4 relative">
    <main class="grid lg:grid-cols-2 gap-16 mt-10">
      <article class="px-4 md:px-8 py-4">
        <payment-link-form
          @successful="paymentLinkCreated('created')"
          :mode="mode"
        />
      </article>
      <aside>
        <!-- top -->
        <!-- <div class="flex flex-col items-center">
          <h3 class="font-semibold text-root-2 text-xl">Preview Link</h3>
          <p class="font-light text-xs">Your customer's view</p>
        </div> -->
        <!-- bottom -->
        <!-- <div class="bottom mt-5 px-4 md:px-8 py-4">
          <preview-link />
        </div> -->
      </aside>
    </main>
    <!-- dialogs -->
    <payment-link-created
      v-if="showPaymentLinkCreated"
      :showDialog="showPaymentLinkCreated"
      :view="view"
      @closeDialog="closeDialog('showPaymentLinkCreated')"
    />
  </div>
</template>

<script>
import createPaymentLink from '@/mixins/paymentLink.js'
export default {
  mixins: [createPaymentLink],
  components: {
    PaymentLinkForm: () =>
      import('@/components/receivePayment/forms/PaymentLinkForm.vue'),
    // PreviewLink: () =>
    //   import('@/components/receivePayment/forms/PreviewLink.vue'),
    PaymentLinkCreated: () =>
      import('@/components/receivePayment/dialogs/PaymentLinkCreated')
  },
  data () {
    return {
      showPaymentLinkCreated: false,
      view: ''
    }
  },
  computed: {
    mode () {
      return this.$route.query.mode
    }
  },
  methods: {
    closeDialog (dialog) {
      this[dialog] = false
    },
    showDialog (dialog) {
      this[dialog] = true
    },
    paymentLinkCreated (view) {
      this.view = view
      this.showDialog('showPaymentLinkCreated')
    }
  }
}
</script>

<style scoped>
article,
.bottom {
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.1),
    0px 8px 16px rgba(3, 2, 7, 0.1);
  border-radius: 15px;
}
</style>
